import produce from "immer";
import {
  SET_USER_DATA,
  SET_SOURCE_INFO,
  GET_MODULE_CODE_SUCCESS,
  SET_CURRENT_DROPDOWN_STATUS,
  CHANGE_CURRENT_DROPDOWN_STATUS,
  RESET_IS_CHANGE_DROPDOWN,
  SET_DIALOG_OPEN,
  CHANGE_LANGUAGE,
  defaultLanguage,
  SET_DIALOG_STATUS,
  FETCH_DATA_CAR_COMPANIES_SUCCESS,
  FETCH_TARGET_LABELS_SUCCESS,
  AUTO_LABELS_REQUEST,
  AUTO_LABELS_SUCCESS,
  AUTO_LABELS_FAILURE,
  SET_REPORTER_TAB,
  GET_AUDIT_LOGS,
  GET_AUDIT_LOGS_SUCCESS,
  GET_AUDIT_LOGS_ERROR,
} from "./constants";
import { getParameterByName } from "helpers";

// The initial state of the App
export const initialState = {
  locale: getParameterByName("locale") || defaultLanguage,
  firebaseToken: "",
  currentUser: {},
  sourceInfo: {
    projectId: null,
    datasetId: null,
    sourceId: null,
    checkLastActive: false,
    customerReview: false,
  },
  inputDataType: "image",
  moduleCode: [],
  currDropDownStatus: [],
  isChangingDropdown: false,
  dialogOpen: false,
  isOpenDialogChangeStatus: false,
  carCompanies: [],
  carBrands: [],
  targetLabels: [],
  isLoadingAutoLabel: false,
  reporterTab: "labeling",
  auditLogsLoading: false,
  auditLogs: [],
  auditUsers: [],
};

const appReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_DIALOG_OPEN:
        draft.dialogOpen = action.payload;
        break;
      case SET_CURRENT_DROPDOWN_STATUS:
        draft.currDropDownStatus = action.payload;
        break;

      case CHANGE_CURRENT_DROPDOWN_STATUS:
        draft.currDropDownStatus = action.payload;
        draft.isChangingDropdown = true;
        break;
      case RESET_IS_CHANGE_DROPDOWN:
        draft.isChangingDropdown = false;
        break;
      case SET_USER_DATA:
        draft.currentUser = action.payload;
        break;

      case SET_SOURCE_INFO: {
        const sourceInfo = {};
        for (let item in action.payload) {
          sourceInfo[item] = JSON.parse(action.payload[item]);
        }
        draft.sourceInfo = sourceInfo;
        break;
      }

      case GET_MODULE_CODE_SUCCESS:
        draft.moduleCode = action.payload;
        break;

      case CHANGE_LANGUAGE:
        draft.locale = action.payload;
        break;
      case SET_DIALOG_STATUS:
        draft.isOpenDialogChangeStatus = action.payload;
        break;
      case FETCH_DATA_CAR_COMPANIES_SUCCESS:
        draft.carCompanies = action.payload;
        break;
      case FETCH_TARGET_LABELS_SUCCESS: {
        draft.targetLabels = action.payload;
        break;
      }
      case AUTO_LABELS_REQUEST: {
        draft.isLoadingAutoLabel = true;
        break;
      }
      case AUTO_LABELS_SUCCESS: {
        draft.isLoadingAutoLabel = false;
        break;
      }
      case AUTO_LABELS_FAILURE: {
        draft.isLoadingAutoLabel = false;
        break;
      }
      case SET_REPORTER_TAB:
        draft.reporterTab = action.payload;
        break;
      case GET_AUDIT_LOGS:
        draft.auditLogsLoading = true;
        break;
      case GET_AUDIT_LOGS_SUCCESS:
        draft.auditLogsLoading = false;
        draft.auditLogs = action.payload.logs || [];
        draft.auditUsers = action.payload.users || [];
        break;
      case GET_AUDIT_LOGS_ERROR:
        draft.auditLogsLoading = false;
        break;
      default:
    }
  });

export default appReducer;
